export const dummyEnrollments = [
  {
    Course_Title: "Data Structures",
    Course_Code: "CS201",
    Section: "A",
    SemesterNo: 3,
    Teacher: "Dr. Ali",
  },
  {
    Course_Title: "Operating Systems",
    Course_Code: "CS301",
    Section: "B",
    SemesterNo: 3,
    Teacher: "Prof. Sara",
  },
];
export const dummyCourses = [
  {
    Course_no: "CS101",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 1,
    SECTION: "A",
    Assi_score: 15,
    Prac_score: 20,
    Midterm_score: 30,
    Final_score: 40,
    Q_points: 3.0,
    Grade: "A",
  },
  {
    Course_no: "CS102",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 2,
    SECTION: "B",
    Assi_score: 12,
    Prac_score: 15,
    Midterm_score: 25,
    Final_score: 30,
    Q_points: 2.0,
    Grade: "F",
  },
  {
    Course_no: "CS101",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 3,
    SECTION: "A",
    Assi_score: 15,
    Prac_score: 20,
    Midterm_score: 30,
    Final_score: 40,
    Q_points: 3.0,
    Grade: "A",
  },
  {
    Course_no: "CS102",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 4,
    SECTION: "B",
    Assi_score: 12,
    Prac_score: 15,
    Midterm_score: 25,
    Final_score: 30,
    Q_points: 2.0,
    Grade: "F",
  },
  {
    Course_no: "CS101",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 5,
    SECTION: "A",
    Assi_score: 15,
    Prac_score: 20,
    Midterm_score: 30,
    Final_score: 40,
    Q_points: 3.0,
    Grade: "A",
  },
  {
    Course_no: "CS102",
    ATTEMPT_NO: 1,
    SEMESTER_NO: 6,
    SECTION: "B",
    Assi_score: 12,
    Prac_score: 15,
    Midterm_score: 25,
    Final_score: 30,
    Q_points: 2.0,
    Grade: "F",
  },
];

export const defaultRules = [
  {
    Key_Name: "getCgpa",
    Type: 1,
    Value: "Select cgpa from Students where reg_no = ?",
    Is_Disabled: false,
  },
  {
    Key_Name: "getAllFailCources",
    Type: 1,
    Value: "Select failCources from Students where reg_no = ?",
    Is_Disabled: false,
  },
  {
    Key_Name: "timeForCompletationDegree",
    Type: 2,
    Value: "12 Semesters",
    Is_Disabled: false,
  },
  {
    Key_Name: "AttendanceRule",
    Type: 2,
    Value: "Minimum 75% attendance is required to sit in exams.",
    Is_Disabled: false,
  },
  {
    Key_Name: "CGPAWarning",
    Type: 2,
    Value: "Students with CGPA below 2.0 will be on probation.",
    Is_Disabled: false,
  },
  {
    Key_Name: "MaxProbations",
    Type: 2,
    Value: "Maximum of 3 probations are allowed during degree.",
    Is_Disabled: false,
  },
  {
    Key_Name: "LabRule",
    Type: 2,
    Value: "Passing lab component is mandatory to pass the course.",
    Is_Disabled: false,
  },
  {
    Key_Name: "RetakePolicy",
    Type: 2,
    Value: "Course can only be retaken if grade is F.",
    Is_Disabled: false,
  },
  {
    Key_Name: "ExamDuration",
    Type: 2,
    Value: "Final exams are of 3 hours duration.",
    Is_Disabled: false,
  },
  {
    Key_Name: "AssignmentPolicy",
    Type: 2,
    Value: "Late assignments will not be accepted.",
    Is_Disabled: false,
  },
  {
    Key_Name: "AddDrop",
    Type: 2,
    Value: "Add/Drop of courses is only allowed in the first 2 weeks.",
    Is_Disabled: false,
  },
];

export const users = [
  {
    regNo: "21-ARID-0000",
    password: "00000",
    role: "Student",
    currentsemesterno: 5,
  },
  { regNo: "adminNo", password: "admin123", role: "Admin" },
  {
    regNo: "advisorNo",
    password: "advisor123",
    role: "Advisor",
    Emp_firstname: "Muhammad",
    Emp_middle: "Jamil",
    Emp_lastname: "Sawar",
  },
];

export const studentsDataForSupercisor = [
  {
    Reg_No: "2021-ARID-1234",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-9234",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-0123",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
  {
    Reg_No: "2021-ARID-1123",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-3456",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-4123",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
  {
    Reg_No: "2021-ARID-4567",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-5123",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-5678",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
  {
    Reg_No: "2021-ARID-6123",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-6234",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-7213",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
  {
    Reg_No: "2021-ARID-7890",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-8123",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-8970",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
  {
    Reg_No: "2021-ARID-0001",
    St_firstname: "Ali",
    St_middlename: "",
    St_lastname: "Khan",
    Final_course: "AI",
    Section: "A",
    currentsemesterno: "Spring 2025",
    Semester_no: 6,
  },
  {
    Reg_No: "2021-ARID-9012",
    St_firstname: "Sara",
    St_middlename: "Ahmad",
    St_lastname: "Khan",
    Final_course: "DBMS",
    Section: "B",
    currentsemesterno: "Spring 2025",
    Semester_no: 4,
  },
  {
    Reg_No: "2021-ARID-2121",
    St_firstname: "Usman",
    St_middlename: "Ilyas",
    St_lastname: "",
    Final_course: "Networks",
    Section: "C",
    currentsemesterno: "Spring 2025",
    Semester_no: 8,
  },
];
